module.exports = __webpack_public_path__ + "assets/img/202107-4.3f04416c.png";